"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const query_string_1 = tslib_1.__importDefault(require("query-string"));
const react_1 = tslib_1.__importStar(require("react"));
const react_if_1 = require("react-if");
const reactstrap_1 = require("reactstrap");
const ModalBody_1 = tslib_1.__importDefault(require("reactstrap/lib/ModalBody"));
const ModalHeader_1 = tslib_1.__importDefault(require("reactstrap/lib/ModalHeader"));
const IntegrationAccessKey_1 = require("../../../comps/resources/IntegrationAccessKey");
const reusables_1 = require("../../../comps/reusables");
const AdminOnly_1 = require("../../../comps/reusables/AdminOnly");
const ApiCredentialsCard_1 = require("./ApiCredentialsCard");
const react_2 = require("@osmosys/react");
const react_hanger_1 = require("react-hanger");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const hooks_1 = require("../../../hooks");
exports.IntegrationSharedSettings = props => {
    const { integration, hasAccessKey, children } = props;
    const { location } = use_react_router_1.default();
    const { state, setState } = react_hanger_1.useSetState({
        failed: false,
    });
    react_1.useEffect(() => {
        const qsParsed = query_string_1.default.parse(location.search);
        setState({
            failed: qsParsed.failed,
        });
    }, [location.search, setState]);
    const closeFailedModal = () => {
        setState({
            failed: undefined,
        });
        location.search = '';
    };
    const { testConnection } = hooks_1.useTestEspConnection();
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EspHome" },
        react_1.default.createElement(reactstrap_1.Row, { className: "mb-2" },
            react_1.default.createElement(reactstrap_1.Col, { md: 7 },
                react_1.default.createElement(reusables_1.FormGroup, { className: "mb-0", label: "Name", name: "name" }),
                children),
            react_1.default.createElement(reactstrap_1.Col, { md: 5 },
                react_1.default.createElement(AdminOnly_1.AdminOnly, { fallback: react_1.default.createElement("p", null, "You must be a workspace admin to edit this integration's settings."), workspaceAdminsAlso: true },
                    react_1.default.createElement(react_if_1.If, { condition: !!hasAccessKey },
                        react_1.default.createElement(ApiCredentialsCard_1.ApiCredentialsCard, null,
                            react_1.default.createElement(IntegrationAccessKey_1.IntegrationAccessKey, { integration: integration, onDelete: () => {
                                    if (integration.isESP) {
                                        testConnection();
                                    }
                                }, onArchive: () => {
                                    if (integration.isESP) {
                                        testConnection();
                                    }
                                } })))),
                props.sidebar)),
        react_1.default.createElement(react_2.OsmosysModal, { osysName: "IntegrationSharedSettings", isOpen: !!state.failed || state.failed === null, centered: true, toggle: closeFailedModal },
            react_1.default.createElement(ModalHeader_1.default, { toggle: closeFailedModal },
                react_1.default.createElement("span", { className: "text-danger" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationTriangle })),
                ' ',
                integration.displayType,
                " error"),
            react_1.default.createElement(ModalBody_1.default, { className: "text-center py-3" },
                react_1.default.createElement("p", { className: "lead mb-0" },
                    "Authentication with ",
                    integration.displayType,
                    " failed."),
                state.failed !== null && typeof state.failed !== 'boolean' && (react_1.default.createElement(reactstrap_1.Input, { className: "mt-2", type: "textarea", value: state.failed, disabled: true }))))));
};
//# sourceMappingURL=IntegrationSharedSettings.js.map